<template>
  <div>
    <p>
      The Achievements page is your central hub to track your progress and stay
      motivated. Here, you can see your total points earned individually as well
      as your group's combined score. You will also find the list of achievement
      badges available in the course. Note that some achievements may be hidden
      until you unlock them.
    </p>

    <p>
      These badges display your progress clearly, showing which achievements you
      have earned, which are partially completed, and which are still locked.
      Together, these elements help you visualize your journey and encourage you
      to keep exploring and learning.
    </p>

    <div class="mb-4">
      <div class="h3 fw-bold mb-3">Achievement Points</div>
      <p>
        On the Achievements page, you will see two point totals at the top: one
        showing your individual points and the other showing your group’s
        combined score.
      </p>
    </div>

    <div>
      <div class="h3 fw-bold mb-3">Achievement Badges</div>
      <p>
        Achievement badges come in different states, each showing key info at a
        glance. Here is how to read them.
      </p>

      <div class="mb-3">
        <div class="fs-5 fw-bold mb-1">Earned Achievement</div>
        <p>
          These badges appear in full color and are fully lit. If you see one
          like this, congrats!
        </p>

        <p>
          The star with a number inside in the top-right indicates how many
          points this achievement is worth. At the bottom of the badge, you will
          see members in your group who have earned this achievement and the
          date you earned it.
        </p>
      </div>

      <div class="mb-3">
        <div class="fs-5 fw-bold mb-1">Partial Achievement</div>
        <p>
          Some achievements require more than one step. These badges will show
          your current progress, such as 1/2, so you know how close you are to
          unlocking it. You will also see members in your group who have earned
          achievements you have partial progress on.
        </p>
      </div>

      <div>
        <div class="fs-5 fw-bold mb-1">Locked Achievement</div>
        <p>
          Locked badges appear dimmed or grayed out. This means you have not
          unlocked them yet, but they are still visible, so you know what is out
          there to earn. You will also see members in your group who have earned
          achievements that are locked for you.
        </p>
      </div>

      <div>
        <div class="fs-5 fw-bold mb-1">Hidden Achievement</div>
        <p>
          Some achievements are hidden until you unlock them. These will not
          appear on your Achievements page until you have earned them.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AchievementsFAQ"
};
</script>
